import React, { FC, useCallback } from 'react';
import { ArgsInput } from './BasicComponents';

import { OperatorProps } from '../../../../@types/TemplateOperators';

interface TextFieldArgProps extends OperatorProps {
  label: string;
  subLabel: string;
  placeholder?: string;
}

const TextFieldArg: FC<TextFieldArgProps> = ({ step, handleArgsChange, label, subLabel, placeholder }) => {
  const { args } = step;
  const [firstArgument] = args;

  const defaultInputHandler = useCallback(
    (value: string) => {
      handleArgsChange([value]);
    },
    [handleArgsChange]
  );

  return (
    <div className="flex mt-6 w-1/2" data-testid={`textfieldarg-operator-${label}`}>
      <ArgsInput
        placeholder={placeholder}
        initialValue={firstArgument || ''}
        onChange={defaultInputHandler}
        label={label}
        subLabel={subLabel}
      />
    </div>
  );
};

export default TextFieldArg;
